import { StatoEnum } from '../_models/generated/stato-enum';
import { STATO_ENUM_UI } from './StatoEnum';

export interface StatoEnumOption {
  value: StatoEnum;
  label: string;
  bg: string;
  text: string;
  icon?: string;
  iconColor?: string;
  animate?: boolean;
}

export const STATO_ENUM_OPTIONS: StatoEnumOption[] =
  Object.entries(STATO_ENUM_UI).map(([key, value]) => ({
    value: Number(key) as StatoEnum, // fondamentale se l'enum è numerico
    label: value.label,
    bg: value.bg,
    text: value.text,
    icon: value.icon,
    iconColor: value.iconColor,
    animate: value.animate
  }));
